import prefetch from '~lib/prefetch';
import { events } from '~services';
import { compose, mapProps, withProps } from 'incompose';
import template from './EventsList';

export default compose(
  prefetch(() => events.fetchTodayUserEvents(), 'events'),
  withProps({
    title: 'Сегодня',
    isTimeShown: true,
  }),
  mapProps(({ events = {}, ...rest }) => ({
    events: events.list,
    ...rest,
  })),
)(template);
